// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_k6-0";
export var fulfillmentPanelBody = "_k6-1";